module.exports = __webpack_public_path__ + "static/media/galerija_2013 (33).cf011ea9.jpg";